import React from 'react';
import { ListItem } from '../list';
export const SearchListEmptyComponent = ({ isLoading, listItemContainerStyle, EmptySearchComponent, }) => {
    if (isLoading) {
        return (React.createElement(React.Fragment, null,
            React.createElement(ListItem, { listItemContainerStyle: listItemContainerStyle }),
            React.createElement(ListItem, { listItemContainerStyle: listItemContainerStyle }),
            React.createElement(ListItem, { listItemContainerStyle: listItemContainerStyle }),
            React.createElement(ListItem, { listItemContainerStyle: listItemContainerStyle }),
            React.createElement(ListItem, { listItemContainerStyle: listItemContainerStyle })));
    }
    return React.createElement(React.Fragment, null, EmptySearchComponent);
};
//# sourceMappingURL=SearchListEmptyComponent.js.map